jQuery(function () {
  const toast = document.getElementById("js-download-toast");

  if (!toast) return;

  let hideTimeout;

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href*="disposition=attachment"]');

    if (!link) return;

    clearTimeout(hideTimeout);
    toast.textContent = "Download gestartet";
    toast.classList.add("download-toast--visible");

    hideTimeout = setTimeout(() => {
      toast.classList.remove("download-toast--visible");
    }, 3000);
  });
});
